// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Play_Filled_Corner0_Rounded = createSinglePathSVG({
  path: 'M22.5 12a1.48 1.48 0 0 1-.712 1.267L8.28 21.53a1.5 1.5 0 0 1-1.519.028A1.49 1.49 0 0 1 6 20.262V3.738a1.49 1.49 0 0 1 .761-1.296 1.5 1.5 0 0 1 1.519.028l13.508 8.263A1.48 1.48 0 0 1 22.5 12Z',
  viewBox: '0 0 24 24',
  glyph: 'Play_Filled_Corner0_Rounded',
})

export const Play_Filled_Corner2_Rounded = createSinglePathSVG({
  path: 'M22.5 12a1.48 1.48 0 0 1-.712 1.267L8.28 21.53a1.5 1.5 0 0 1-1.519.028A1.49 1.49 0 0 1 6 20.262V3.738a1.49 1.49 0 0 1 .761-1.296 1.5 1.5 0 0 1 1.519.028l13.508 8.263A1.48 1.48 0 0 1 22.5 12Z',
  viewBox: '0 0 24 24',
  glyph: 'Play_Filled_Corner2_Rounded',
})

export const Play_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M21.788 10.733 8.28 2.47a1.5 1.5 0 0 0-1.519-.028A1.49 1.49 0 0 0 6 3.738v16.524a1.494 1.494 0 0 0 1.5 1.488 1.5 1.5 0 0 0 .784-.22l13.504-8.263a1.482 1.482 0 0 0 0-2.532ZM7.5 20.244V3.75L20.984 12Z',
  viewBox: '0 0 24 24',
  glyph: 'Play_Stroke2_Corner0_Rounded',
})

export const Play_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M21.788 10.733 8.28 2.47a1.5 1.5 0 0 0-1.519-.028A1.49 1.49 0 0 0 6 3.738v16.524a1.494 1.494 0 0 0 1.5 1.488 1.5 1.5 0 0 0 .784-.22l13.504-8.263a1.482 1.482 0 0 0 0-2.532ZM7.5 20.244V3.75L20.984 12Z',
  viewBox: '0 0 24 24',
  glyph: 'Play_Stroke2_Corner2_Rounded',
})
